import { render } from "./driver-request.vue?vue&type=template&id=044a0c43&scoped=true"
import script from "./driver-request.vue?vue&type=script&lang=js"
export * from "./driver-request.vue?vue&type=script&lang=js"

import "./driver-request.vue?vue&type=style&index=0&id=044a0c43&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-044a0c43"]])

export default __exports__